var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_vm._v(" 天星健康 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }